import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/session-import-actions-types';

import type {List} from 'immutable';

export type SessionImportStore = {
    locations: List<unknown>;
    scenarios: List<unknown>;
    allowedVideoFormats: List<unknown>;
};

const initialState = () => {
    return {
        locations: Immutable.List(),
        scenarios: Immutable.List(),
        allowedVideoFormats: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.LOCATIONS_SUCCESS]: (state, action) => {
        return {
            locations: action.data,
        };
    },

    [actionTypes.SCENARIOS_SUCCESS]: (state, action) => {
        return {
            scenarios: action.data,
        };
    },

    [actionTypes.ALLOWED_FORMATS_SUCCESS]: (state, action) => {
        return {
            allowedVideoFormats: action.data,
        };
    },

    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<SessionImportStore>(initialState(), actionsMap);
